import styled from "styled-components";
import theme from '../../theme';

const PriceUnit = styled.span`
    font-size: ${props => props.fontSize ? props.fontSize : theme.fontSize.h5}px;
    margin-left: 10px;
`

export default PriceUnit